import Vue from 'vue'
import Router from 'vue-router'

import IndexPage from '@/pages/index'
import technology from '@/pages/technology'
import partners from '@/pages/partners'
import about from '@/pages/about'

Vue.use(Router)

export default new Router({
	// history模式，去除URL中#
	mode: 'hash',
	// 解决路由跳转后，不显示在首行
	scrollBehavior() {
		return {x: 0, y: 0};
	},
	routes: [
		{
			path: '/',
			name: 'index',
			component: IndexPage
		},
		{
			path: '/technology',
			name: 'technology',
			component: technology
		},
		{
			path: '/partners',
			name: 'partners',
			component: partners,
			meta: {
				clearCache: true // 设置缓存清除字段
			}
		},
		{
			path: '/about',
			name: 'about',
			component: about
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js